(function() {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('portal-notification', {
            parent: 'entity',
            url: '/portal-notification?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.portalNotification.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/portal-notification/portal-notifications.html',
                    controller: 'PortalNotificationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portalNotification');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('portal-notification-detail', {
            parent: 'portal-notification',
            url: '/portal-notification/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.portalNotification.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/portal-notification/portal-notification-detail.html',
                    controller: 'PortalNotificationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portalNotification');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PortalNotification', function($stateParams, PortalNotification) {
                    return PortalNotification.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'portalNotification',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('portal-notification.new', {
            parent: 'portal-notification',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-notification/portal-notification-dialog.html',
                    controller: 'PortalNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                subject: null,
                                message: null,
                                category: null,
                                priority: null,
                                date: null,
                                isRead: false,
                                notificationToUser: null,
                                destination: null,
                                companyDestination: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('portal-notification', null, { reload: 'portal-notification' });
                }, function() {
                    $state.go('portal-notification');
                });
            }]
        })
        .state('portal-notification.delete', {
            parent: 'portal-notification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-notification/portal-notification-delete-dialog.html',
                    controller: 'PortalNotificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PortalNotification', function(PortalNotification) {
                            return PortalNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('portal-notification', null, { reload: 'portal-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
